import React from "react";
import { compareEmoji, emojiForCompanion } from "../utils/companionPlay";

export default function CompanionPanel({ companionName, companionResults, currentLevel, levelTimesToday }) {
  if (!companionResults) return null;

  const companionThisLevel = companionResults[currentLevel - 1];
  const kidTimeThisLevel = levelTimesToday?.[currentLevel - 1];
  const feedback = kidTimeThisLevel ? compareEmoji(kidTimeThisLevel, companionThisLevel?.timeTakenSec) : null;

  return (
    <div className="mx-auto max-w-md sm:max-w-lg px-4 mt-2">
      <div className="bg-white/10 rounded-2xl px-3 py-2 flex items-center justify-between text-xs text-white">
        <div className="flex items-center gap-1.5">
          <span aria-hidden="true">{emojiForCompanion(companionName)}</span>
          <span className="font-semibold">{companionName}: {companionThisLevel?.timeTakenSec ?? "–"}s</span>
        </div>
        <div className="flex items-center gap-1.5">
          {feedback && <span aria-hidden="true" title={feedback.label}>{feedback.emoji}</span>}
          <span className="font-semibold">You: {kidTimeThisLevel != null ? `${kidTimeThisLevel}s` : "…"}</span>
        </div>
      </div>
    </div>
  );
}